<template>
  <div class="rte" :class="{ 'rte--disabled': disabled }">
    <div class="rte__toolbar">
      <button class="rte__btn" @mousedown.prevent="exec('bold')" title="Grassetto"><strong>B</strong></button>
      <button class="rte__btn rte__btn--italic" @mousedown.prevent="exec('italic')" title="Corsivo">I</button>
      <button class="rte__btn rte__btn--underline" @mousedown.prevent="exec('underline')" title="Sottolineato">U</button>
      <span class="rte__sep"></span>
      <select class="rte__size" @mousedown.stop :value="currentFontSize" @change="setFontSize($event)" title="Dimensione testo">
        <option value="">A</option>
        <option value="1">Piccolo</option>
        <option value="3">Normale</option>
        <option value="5">Grande</option>
        <option value="7">Enorme</option>
      </select>
      <span class="rte__sep"></span>
      <button class="rte__btn" @mousedown.prevent="exec('insertUnorderedList')" title="Lista puntata"><v-icon small>format_list_bulleted</v-icon></button>
      <button class="rte__btn" @mousedown.prevent="openLinkDialog" title="Inserisci link"><v-icon small>link</v-icon></button>
      <span class="rte__sep"></span>
      <button class="rte__btn" @mousedown.prevent="exec('removeFormat')" title="Rimuovi formattazione"><v-icon small>format_clear</v-icon></button>
    </div>
    <div
      ref="content"
      class="rte__content"
      :contenteditable="String(!disabled)"
      :data-placeholder="placeholder"
      @input="onInput"
      @blur="onInput"
      @keyup="updateFontSize"
      @mouseup="updateFontSize"
    ></div>
    <v-dialog v-model="linkDialog.show" max-width="420" eager>
      <v-card>
        <v-card-title class="subtitle-1 font-weight-bold">Inserisci link</v-card-title>
        <v-card-text class="pb-0">
          <v-text-field
            v-model="linkDialog.text"
            label="Testo visualizzato"
            outlined
            dense
            hide-details
            class="mb-3"
          ></v-text-field>
          <v-text-field
            ref="linkUrlField"
            v-model="linkDialog.url"
            label="URL (es. https://esempio.it)"
            outlined
            dense
            hide-details
            @keydown.enter="confirmLink"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="linkDialog.show = false">Annulla</v-btn>
          <v-btn color="primary" text @click="confirmLink">Inserisci</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>  </div>
</template>

<script>
export default {
  name: "RichTextEditor",
  props: {
    value:       { type: String,  default: ""    },
    disabled:    { type: Boolean, default: false },
    placeholder: { type: String,  default: ""    },
  },
  data() {
    return {
      currentFontSize: "",
      linkDialog: {
        show: false,
        url: "",
        text: "",
      },
    };
  },
  mounted() {
    this.$refs.content.innerHTML = this.value || "";
  },
  watch: {
    value(newVal) {
      if ((newVal || "") !== this.$refs.content.innerHTML)
        this.$refs.content.innerHTML = newVal || "";
    },
  },
  methods: {
    exec(cmd) {
      if (this.disabled) return;
      this.$refs.content.focus();
      document.execCommand(cmd, false, null);
    },
    setFontSize(event) {
      const size = event.target.value;
      if (!size || this.disabled) return;
      this.$refs.content.focus();
      document.execCommand("fontSize", false, size);
      this.currentFontSize = size;
      this.onInput();
    },
    updateFontSize() {
      const sel = window.getSelection();
      if (!sel || sel.rangeCount === 0) return;
      let node = sel.anchorNode;
      if (node && node.nodeType === Node.TEXT_NODE) node = node.parentElement;
      while (node && node !== this.$refs.content) {
        const fs = node.getAttribute && node.getAttribute("size");
        if (fs) { this.currentFontSize = fs; return; }
        node = node.parentElement;
      }
      this.currentFontSize = "";
    },
    onInput() {
      this.$emit("input", this.$refs.content.innerHTML);
    },
    openLinkDialog() {
      if (this.disabled) return;
      const sel = window.getSelection();
      // Store Range as plain instance property — NOT in reactive data,
      // because Vue 2 would wrap it in a proxy and corrupt the DOM object.
      this._savedRange = sel && sel.rangeCount > 0 ? sel.getRangeAt(0).cloneRange() : null;
      this.linkDialog.text = this._savedRange ? this._savedRange.toString() : "";
      this.linkDialog.url = "";
      this.linkDialog.show = true;
      this.$nextTick(() => {
        this.$refs.linkUrlField && this.$refs.linkUrlField.focus();
      });
    },
    confirmLink() {
      const url = (this.linkDialog.url || "").trim();
      const text = (this.linkDialog.text || "").trim();
      this.linkDialog.show = false;
      if (!url) return;
      this.$nextTick(() => {
        this.$refs.content.focus();
        const sel = window.getSelection();
        if (this._savedRange) {
          sel.removeAllRanges();
          sel.addRange(this._savedRange);
        }
        const a = document.createElement("a");
        a.href = url;
        a.target = "_blank";
        a.rel = "noopener noreferrer";
        a.textContent = text || url;
        if (sel && sel.rangeCount > 0) {
          const range = sel.getRangeAt(0);
          range.deleteContents();
          range.insertNode(a);
          range.setStartAfter(a);
          range.collapse(true);
          sel.removeAllRanges();
          sel.addRange(range);
        }
        this.onInput();
      });
    },
  },
};
</script>

<style scoped>
.rte { border-radius: 4px; background: #f5f5f5; overflow: hidden; border: 1px solid #e0e0e0; }
.rte--disabled { opacity: 0.45; pointer-events: none; }
.rte__toolbar { display: flex; align-items: center; padding: 4px 6px; background: #eeeeee; border-bottom: 1px solid #e0e0e0; gap: 2px; flex-wrap: wrap; }
.rte__btn { border: none; background: transparent; cursor: pointer; padding: 2px 7px; border-radius: 3px; font-size: 13px; color: #444; display: inline-flex; align-items: center; justify-content: center; min-width: 28px; height: 28px; }
.rte__btn:hover { background: #ddd; }
.rte__btn--italic { font-style: italic; font-family: serif; }
.rte__btn--underline { text-decoration: underline; }
.rte__sep { display: inline-block; width: 1px; height: 20px; background: #ccc; margin: 0 4px; }
.rte__content { min-height: 100px; padding: 10px 12px; outline: none; font-size: 14px; line-height: 1.6; color: #333; background: #f5f5f5; word-break: break-word; }
.rte__content:empty::before { content: attr(data-placeholder); color: #aaa; pointer-events: none; }
.rte__size { border: 1px solid #ccc; background: transparent; cursor: pointer; padding: 0 4px; border-radius: 3px; font-size: 12px; color: #444; height: 28px; outline: none; }
.rte__size:hover { background: #ddd; }
</style>



// WEBPACK FOOTER //
// src/components/utils/RichTextEditor.vue